import { DialogComponent } from '@theme/dialog';
import { WishlistStorage } from './wishlist-storage.js';
import { ThemeEvents } from '@theme/events';

/**
 * A custom element that manages a wishlist drawer.
 *
 * @extends {DialogComponent}
 */
class WishlistDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(ThemeEvents.wishlistUpdate, this.#render);
    this.#render();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(ThemeEvents.wishlistUpdate, this.#render);
  }

  #render = () => {
    const container = this.querySelector('.wishlist-drawer__items');
    if (!container) return;

    const items = WishlistStorage.get();
    const emptyEl = this.querySelector('.wishlist-drawer__empty');
    const contentEl = this.querySelector('.wishlist-drawer__content');
    const viewProductLabel = this.dataset.viewProduct || 'View product';
    const removeLabel = this.dataset.removeLabel || 'Remove from wishlist';

    if (emptyEl) emptyEl.classList.toggle('hidden', items.length > 0);
    if (contentEl) contentEl.classList.toggle('hidden', items.length === 0);

    container.innerHTML = items
      .map(
        (item) => `
      <div class="wishlist-drawer__item" data-product-id="${this.#escapeHtml(item.id)}">
        <a href="${this.#escapeHtml(item.url)}" class="wishlist-drawer__item-image">
          ${item.image ? `<img src="${this.#escapeHtml(item.image)}" alt="" loading="lazy" width="80" height="80">` : ''}
        </a>
        <div class="wishlist-drawer__item-details">
          <a href="${this.#escapeHtml(item.url)}" class="wishlist-drawer__item-title">${this.#escapeHtml(item.title)}</a>
          ${item.price ? `<span class="wishlist-drawer__item-price">${item.price}</span>` : ''}
          <div class="wishlist-drawer__item-actions">
            <a href="${this.#escapeHtml(item.url)}" class="button button--secondary button--small">${this.#escapeHtml(viewProductLabel)}</a>
            <button type="button" class="button button--plain wishlist-drawer__remove" data-product-id="${this.#escapeHtml(item.id)}" aria-label="${this.#escapeHtml(removeLabel)}">
              <span class="svg-wrapper"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.5 9v4.25M8.5 9v4.25M5.75 12.2V6h8.5c0 2.421 0 3.779 0 6.2 0 .853 0 1.447-.038 1.91-.037.453-.106.714-.207.911a2.498 2.498 0 0 1-.983 1.017c-.197.1-.458.17-.911.207-.463.037-1.057.038-1.91.038h-.4c-.853 0-1.447 0-1.91-.038-.453-.037-.714-.106-.911-.207a2.498 2.498 0 0 1-.984-1.017c-.1-.197-.17-.458-.207-.911C5.75 13.647 5.75 13.053 5.75 12.2z" stroke="currentColor" stroke-width="var(--icon-stroke-width, 1.5)" stroke-linecap="round"/><path d="M4.25 6h11.5M8 5.25a2 2 0 1 1 4 0" stroke="currentColor" stroke-width="var(--icon-stroke-width, 1.5)" stroke-linecap="round" stroke-linejoin="round"/></svg></span>
            </button>
          </div>
        </div>
      </div>
    `
      )
      .join('');

    container.querySelectorAll('.wishlist-drawer__remove').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        WishlistStorage.remove(btn.dataset.productId);
      });
    });

  };

  #escapeHtml(str) {
    if (!str) return '';
    const div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  open() {
    this.showDialog();
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('wishlist-drawer-component')) {
  customElements.define('wishlist-drawer-component', WishlistDrawerComponent);
}
